import PocImg from "public/pocCloud/poc-as-a-service.jpg";

export const INTRO_CONSTANTS = {
  title: "Proof-of-Concept as a Service (POCaaS), Simplified by OneMind",
  description: [
    "Test smarter, deploy with confidence. OneMind’s POCaaS enables organizations to evaluate new technologies, software, or integrations in a fully managed, cloud-based environment—before committing to production.",
    "By creating a digital twin of your real-world infrastructure, we help you validate feasibility, performance, and compatibility—without the cost or complexity of traditional IT setups.",
  ],
  points: [
    "Real-World Testing Without the Risk : Simulate production environments to evaluate functionality and outcomes.",
    "Accelerate Decision-Making : Quickly validate if a solution meets your technical and business requirements.",
    "No Infrastructure Overhead : All testing environments are hosted, managed, and scaled by OneMind—zero on-prem investment required.",
  ],
  image: PocImg,
};
